import { TileMapRenderer as TileMapRenderer2D } from './TileMapRenderer2D';
import { TileMapRenderer as TileMapRenderer3D } from '../3d/TileMapRenderer3D';
import { TileMapRendererWorld2D } from '../world2d/TileMapRendererWorld2D';
import type { TileMapRendererOptions } from './types';

export type TileMapRenderer = TileMapRenderer2D | TileMapRenderer3D | TileMapRendererWorld2D;

export async function createTileMapRenderer(
  mode: '2d' | '3d' | 'world2d',
  options: TileMapRendererOptions,
): Promise<TileMapRenderer> {
  if (mode === '2d') {
    return TileMapRenderer2D.create(options);
  }
  if (mode === 'world2d') {
    return TileMapRendererWorld2D.create(options);
  }
  return TileMapRenderer3D.create(options);
}

export * from './types';
export * from './constants';
